/*
 * Copyright (c)2024. J <info_together@aliyun.com> All Rights Reserved.
 */

const catchErrorInterceptors = {
  onFulfilled: (response: any) => {
    // 2xx 范围内的状态码都会触发该函数。
    if(!response?.data?.success){
     
    }
    return response;
  },
  onRejected: (error: any) => {
    // 超出 2xx 范围的状态码都会触发该函数。
    
  },
}

export default catchErrorInterceptors;
